/*******************************************************************************
 * Project：
 * Summary:
 *　　 User MstHTOrg
 * Remarks:
 *    Define Reducers for MstHTOrg
 * History：
 *    ThaiTV            2022/01/05    Create
 ******************************************************************************/
import { EMstHTOrgActions, MstHTOrgActions } from '../actions/mstHTOrg.action';
import { IMstHTOrgState, initialMstHTOrgState } from '../states/mstHTOrg.state';

export const mstHTOrgReducers = (
    state = initialMstHTOrgState,
    action: MstHTOrgActions
): IMstHTOrgState => {
    switch (action.type) {
        case EMstHTOrgActions.GetMstHTOrg: {
            return {
                ...state,
                selectedIMstHTOrg: action.payload
            };
        }
        default:
            return state;
    }
};
